import { SalesforceProduct } from '~/lib/salesforce/types';
import { DISCONTINUED_STORE_FORMATS } from './is-discontinued-store-format';

const DEAD_STORE_FORMATS: string[] = ['040', '051', ...DISCONTINUED_STORE_FORMATS];

/*
    Dead product is defined by:
    
    Store format codes
        Code 040
        Code 050
        Code 051
        Code 070 (discontinued product)
        Code 080 (obsolete product)
        Code 088 (discontinued/dead product in store),
    or Product status code that ends with "P",
    and false in stock.
*/
export const isDeadProduct = (product: SalesforceProduct) => {
    const { c_storeFormat, c_in_stock, c_productStatusCode, c_isRemainder } = product;

    return (
        (DEAD_STORE_FORMATS.includes(c_storeFormat ?? '') ||
            !!c_productStatusCode?.endsWith('P') ||
            c_isRemainder) &&
        !c_in_stock
    );
};
